module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-thunder-463e4ace970fef489145b37a45513b7f.svg";